'use client'

import { useEffect, useState } from 'react'
import { Answer } from '@schemas/non-auth'
import UIRadio from '@components/ui/UIRadio'
import UIRadioGroup from '@components/ui/UIRadioGroup'
import { Box } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'
import UIFlex from '@components/ui/UIFlex'
import color from '@ui/style/color.theme'
import PollTextarea from './PollTextarea'
import { PollSetProps } from './types'

const PollRadioSet = ({
	poll,
	auth,
	selected,
	setSelected,
	setAnswer,
	authAction,
}: PollSetProps) => {
	const [subjective, setSubjective] = useState<string>('')
	const targetCode = poll.participationTargetCode?.code
	const checkSubjective = (answer: Answer) => answer.answerTypeCode.code === 'SUBJECTIVE'
	const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (targetCode === 'MEMBER-ONLY' && !auth) {
			authAction()
		} else if ((targetCode === 'MEMBER-ONLY' && auth) || targetCode === 'ALL') {
			setSelected([e.target?.value as string])
		}
	}
	useEffect(() => {
		const selectedAnswer = poll.answerList?.find((item) =>
			selected.includes(item.answerIdx.toString()),
		)
		if (selectedAnswer && checkSubjective(selectedAnswer as Answer)) {
			setAnswer?.(subjective)
		} else {
			setAnswer?.(undefined)
		}
	}, [poll, selected, subjective])
	return (
		<UIFlex
			px={pxToRem(12)}
			borderRadius={pxToRem(8)}
			sx={{
				background: color.colWhite,
			}}
		>
			<UIRadioGroup name="poll-radio-group">
				{poll.answerList?.map((answer, index) => {
					const isSubjective = checkSubjective(answer)
					return (
						<Box
							display="block"
							py={pxToRem(12)}
							borderTop={index > 0 ? `1px solid ${color.colGray3}` : undefined}
							key={`poll-answer-${answer.answerIdx}`}
						>
							<UIRadio
								value={answer.answerIdx}
								checked={selected.includes(answer.answerIdx.toString())}
								label={answer.answerContent}
								onChange={handleSelect}
								sx={
									isSubjective
										? { '&.Mui-checked + .poll-textarea': { display: 'flex' } }
										: undefined
								}
							/>
							{isSubjective && (
								<PollTextarea
									onChange={setSubjective}
									sx={{
										marginTop: pxToRem(10),
										marginLeft: '-1px',
										marginRight: '-1px',
										display: 'none',
										'&:focus-within': {
											border: `1px solid ${color.colDarkBlue}`,
										},
									}}
								/>
							)}
						</Box>
					)
				})}
			</UIRadioGroup>
		</UIFlex>
	)
}

export default PollRadioSet
